module.exports = __webpack_public_path__ + "static/media/birthDateCalender.8e1cb194.svg";